import { createReducer, on } from "@ngrx/store";
import { IExtracurricular } from "../../models/academic";
import { ActivityActions } from "./activity.actions";
import { resetAppState } from "../global/global.actions";

export interface ActivityState {
    activities: IExtracurricular[] | null;
    selectedActivity: IExtracurricular | null;
    loading: boolean;
    error: unknown | null;
}

export const initialState: ActivityState = {
    activities: null,
    selectedActivity: null,
    loading: false,
    error: null
};

export const activityReducer = createReducer(
    initialState,

    // Load Activities
    on(ActivityActions.loadActivities, (state) => ({
        ...state,
        loading: true,
        error: null
    })),

    // Load Activities Success
    on(ActivityActions.loadActivitiesSuccess, (state, { activities }) => ({
        ...state,
        activities,
        loading: false,
        error: null
    })),

    // Load Activities Failure
    on(ActivityActions.loadActivitiesFailure, (state, { error }) => ({
        ...state,
        loading: false,
        error
    })),

    // Select Activity
    on(ActivityActions.selectActivity, (state, { id }) => ({
        ...state,
        selectedActivity: state.activities?.find(activitity => activitity.id === id) || null
    })),
    on(resetAppState, () => initialState)
);

